var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 55 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.995.224a.764.764 0 0 1 0 1.08L2.6 13.737h51.64A.76.76 0 0 1 55 14.5a.764.764 0 0 1-.76.763H2.598l12.396 12.434a.764.764 0 0 1-.83 1.245.762.762 0 0 1-.246-.166L.223 15.04a.763.763 0 0 1 0-1.08L13.92.224a.76.76 0 0 1 1.076 0Z"
  })));
};
export default SvgLeftArrow;